<template>
    <li class="playerItem">
        <router-link
            v-if="pending"
            class="pending"
            :to="{ name: 'proPlayerPending', params: { id: player.id } }"
        >
            {{ player.first_name }} {{ player.last_name }}
            <chevron-right-icon class="icon"></chevron-right-icon>
        </router-link>

        <a v-else href="#" @click.prevent="clearActivePlayer">
            {{ player.first_name }} {{ player.last_name }}
            <chevron-right-icon class="icon"></chevron-right-icon>

            <span
                class="counter"
                v-if="
                    this.$store.state.user.incompleteLessonRecordsByPlayerId &&
                    this.$store.state.user.incompleteLessonRecordsByPlayerId[player.id]
                "
            >
                {{ this.$store.state.user.incompleteLessonRecordsByPlayerId[player.id] }}
            </span>
        </a>
    </li>
</template>

<script>
import { ChevronRightIcon } from "vue-feather-icons";
export default {
    name: "player-item",
    components: { ChevronRightIcon },
    props: {
        pending: {
            type: Boolean,
            required: false,
        },
        player: {
            type: Object,
            required: true,
        },
    },
    methods: {
        clearActivePlayer() {
            this.$store.dispatch("clearActivePlayer");
            this.$router.push({
                name: "proPlayer",
                params: { id: this.player.id },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.playerItem {
    position: relative;
    border-bottom: 1px solid white;
    a {
        display: block;
        color: $green_0;
        text-decoration: none;
        padding: 17px;
        height: 52px;
        background: #eef5f2;
        border-radius: 12px;
        margin-bottom: 10px;
        position: relative;
        .icon {
            position: absolute;
            top: 6px;
            position: absolute;
            right: 6px !important;
            top: 14px;
            width: 18px;
        }
        &.pending {
            background: #bbf8e0;
        }
    }
    &:last-of-type {
        border-bottom: 0px;
    }

    .counter {
        display: block;
        position: absolute;
        width: 20px;
        height: 20px;
        border-radius: 100%;
        top: -5px;
        font-size: 12px;
        left: -5px;
        line-height: 20px;
        text-align: center;
        background: #267962;
        color: white;
    }
}
</style>
